import { makeRequest } from 'cityads-v3/utils/apiUtils';

import { amplitudeSendEvent } from 'cityads-v3/utils/counterUtils';

export const REMOTE_AUTH_GET = 'api_auth/REMOTE_AUTH_GET';
export const REMOTE_AUTH_GET_SUCCESS = 'api_auth/REMOTE_AUTH_GET_SUCCESS';
export const REMOTE_AUTH_GET_FAILURE = 'api_auth/REMOTE_AUTH_GET_FAILURE';
export const REMOTE_AUTH_CHANGE = 'api_auth/REMOTE_AUTH_CHANGE';
export const REMOTE_AUTH_CHANGE_SUCCESS = 'api_auth/REMOTE_AUTH_CHANGE_SUCCESS';
export const REMOTE_AUTH_CHANGE_FAILURE = 'api_auth/REMOTE_AUTH_CHANGE_FAILURE';

export const OAUTH_20_GET = 'api_auth/OAUTH_20_GET';
export const OAUTH_20_GET_SUCCESS = 'api_auth/OAUTH_20_GET_SUCCESS';
export const OAUTH_20_GET_FAILURE = 'api_auth/OAUTH_20_GET_FAILURE';
export const OAUTH_20_CHANGE = 'api_auth/OAUTH_20_CHANGE';
export const OAUTH_20_CHANGE_SUCCESS = 'api_auth/OAUTH_20_CHANGE_SUCCESS';
export const OAUTH_20_CHANGE_FAILURE = 'api_auth/OAUTH_20_CHANGE_FAILURE';

export function getRemoteAuth() {
  return makeRequest(`/saduka/remoteAuth`, {
    types: [REMOTE_AUTH_GET, REMOTE_AUTH_GET_SUCCESS, REMOTE_AUTH_GET_FAILURE],
    options: {
      credentials: 'include',
    },
  });
}

export function changeRemoteAuth() {
  amplitudeSendEvent('makeActions', 'd-v1-e16', 'office', 'api_remote_auth_change');

  return makeRequest(`/saduka/remoteAuth`, {
    types: [REMOTE_AUTH_CHANGE, REMOTE_AUTH_CHANGE_SUCCESS, REMOTE_AUTH_CHANGE_FAILURE],
    options: {
      credentials: 'include',
      method: 'POST',
    },
  });
}

export function getOAuth2Credentials() {
  return makeRequest(`/saduka/auth/client`, {
    types: [OAUTH_20_GET, OAUTH_20_GET_SUCCESS, OAUTH_20_GET_FAILURE],
    options: {
      credentials: 'include',
    },
  });
}

export function changeOAuth2Credentials() {
  return makeRequest(`/saduka/auth/client`, {
    types: [OAUTH_20_CHANGE, OAUTH_20_CHANGE_SUCCESS, OAUTH_20_CHANGE_FAILURE],
    options: {
      credentials: 'include',
      method: 'POST',
    },
  });
}
